import { TPAComponentProps } from '../../types';

import { ProgressBarProps } from '../ProgressBar';

export interface ReviewSummaryProps extends TPAComponentProps {
  /** The review summary items. */
  items: Omit<ProgressBarProps, 'aria-hide-affixes' | 'role'>[];
  /** Gives the ReviewSummary an accessible description by referring to the content that describes the purpose of the ReviewSummary. */
  'aria-describedby'?: string;
  /** Defines a string value that labels the drawer element. */
  'aria-label'?: string;
}

export enum ReviewSummaryDataHooks {
  Item = 'item',
}
